import React from "react";
import { Helmet } from "react-helmet-async";

const LocalBusinessSchema = () => {
  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": "https://exe.levelstair.com/#organization",
    name: "Levelstair",
    alternateName: "LEVELSTAIR",
    description:
      "Sri Lanka's premier game development community. We offer Game Development workshops, and monthly game jams for aspiring game developers.",
    url: "https://exe.levelstair.com",
    logo: {
      "@type": "ImageObject",
      url: "https://exe.levelstair.com/ExeLogo.png",
      width: 512,
      height: 512,
    },
    image: "https://exe.levelstair.com/ShareImage.png",
    foundingDate: "2024-08-14",
    address: {
      "@type": "PostalAddress",
      addressCountry: "LK",
      addressRegion: "Western Province",
      addressLocality: "Colombo",
      postalCode: "00100",
    },
    geo: {
      "@type": "GeoCoordinates",
      latitude: 6.9271,
      longitude: 79.8612,
    },
    areaServed: [
      {
        "@type": "Country",
        name: "Sri Lanka",
      },
      {
        "@type": "AdministrativeArea",
        name: "Colombo",
      },
    ],
    knowsAbout: [
      "Game Development",
      "Unity 3D",
      "Unreal Engine",
      "Godot Engine",
      "C# Programming",
      "Game Design",
      "3D Modeling",
      "Game Animation",
      "Indie Game Development",
      "Mobile Game Development",
      "PC Game Development",
      "Game Art",
      "Game Programming",
      "Game Development Sri Lanka",
      "Vtubing Sri Lanka",
      "PNGTubing Sri Lanka",
      "Live Streaming in Sri Lanka",
    ],
    audience: {
      "@type": "Audience",
      audienceType:
        "Game Developers, Students, Professionals, Gamers, Esports Players, Vtubers, YouTubers, Undergraduates",
      geographicArea: "Sri Lanka",
    },
    memberOf: [
      {
        "@type": "Organization",
        name: "Sri Lankan Game Development Community",
      },
    ],
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: "Game Development Services",
      itemListElement: [
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Course",
            name: "Game Development Workshop",
            description:
              "Learn game development concepts",
          },
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Event",
            name: "Level Zero Game Jam",
            description:
              "Monthly 48-hour game development challenge for beginners",
          },
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Event",
            name: "EXE Competition",
            description:
              "Month-long game design and development challenge for beginners and experts",
          },
        },
      ],
    },
    sameAs: [
      "https://www.facebook.com/LEVELSTAIR",
      "https://www.instagram.com/levelstair",
      "https://www.linkedin.com/company/levelstair",
      "https://twitter.com/levelstair",
      "https://www.youtube.com/@LEVELSTAIR",
      "https://discord.gg/xauShxdx6u",
      "https://levelstair.itch.io/",
    ],
    contactPoint: {
      "@type": "ContactPoint",
      contactType: "customer support",
      areaServed: "LK",
      availableLanguage: ["en", "si"],
    },
  };

  return (
    <Helmet>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(localBusinessSchema),
        }}
      />
    </Helmet>
  );
};

export default LocalBusinessSchema;
